import { globalVariables } from "helper/globalVariables";
import { ROLE } from "helper/utility";
import { useEffect, useState } from "react";
import { Button } from "shared/Components/button";
import Loader from "shared/Components/loader";
import MultiSelectDropdown from "shared/Components/multiselectDropdown";

export const UserListCard = ({
  loading,
  userDetail,
  onViewMoreClick,
  onClick,
  handleUpdateRole,
  userRoles,
  editable = true,
}) => {
  const [loadingIndex, setLoadingIndex] = useState();
  useEffect(() => {
    if (!loading) {
      setLoadingIndex();
    }
  }, [loading]);

  return (
    <div
      class="bg-white p-4 flex flex-col flex-1 result-card-box"
      onClick={() => onClick?.(userDetail)}
    >
      <div className="flex flex-col">
        <div className="flex flex-row justify-between">
          <span class="text-lg font-semibold text-gray-900">
            {globalVariables.name}: {userDetail.name}
          </span>
          {/* <Dropdown
            width={"w-36"}
            className="h-8 rounded-3xl"
            isFaded={true}
          /> */}
          {editable ? (
            <MultiSelectDropdown
              dropdownOptions={
                loading
                  ? []
                  : userRoles?.map((userRole) =>
                      userDetail?.role?.includes(userRole?.title)
                        ? {
                            ...userRole,
                            isSelected: true,
                          }
                        : { ...userRole }
                    )
              }
              placeholder={
                loading && loadingIndex === userDetail?.id ? (
                  <Loader stroke="text-gradient-500" />
                ) : (
                  userDetail?.role?.join(", ") || ROLE.Member
                )
              }
              width={"w-[150px]"}
              // defaultOption={roles[0]}
              className={loading ? "h-10" : "h-auto"}
              onChange={(updateOptions) => {
                // setUserRoles(updateOptions);
                setLoadingIndex(userDetail?.id);
                handleUpdateRole({
                  authId: userDetail?.authId,
                  roles: updateOptions
                    ?.filter((option) => option?.isSelected)
                    ?.map((options) => options?.title),
                });
              }}
            />
          ) : (
            <span>{userDetail?.role ? userDetail?.role?.join(", ") : "-"}</span>
          )}
        </div>
        <span class="text-sm text-gray-600 font-semibold">
          {globalVariables.email}: {userDetail.email}
        </span>
      </div>
      <div className="pt-8 flex justify-end">
        <Button
          label={globalVariables.viewMore}
          width="w-32"
          onClick={onViewMoreClick}
        />
      </div>
    </div>
  );
};
